(() => {
  'use strict';
  function init(root) {
    root.querySelectorAll('[data-fr-app-root]').forEach(stage => {
      if (stage.dataset.ready) return;
      stage.dataset.ready = 'true';
      const phone = stage.querySelector('[data-fr-app]');
      const sky = phone.querySelector('.fr-app__sky');
      const canvas = phone.querySelector('canvas');
      const ctx = canvas.getContext('2d');
      const button = stage.querySelector('button');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false, paused = false, started = false;
      if (!ctx) return;
      function draw() {
        const width = sky.clientWidth, height = sky.clientHeight;
        if (!width || !height) return;
        const ratio = Math.min(devicePixelRatio || 1, 2);
        canvas.width = width * ratio; canvas.height = height * ratio;
        ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
        let seed = 9;
        const random = () => { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
        for (let i = 0; i < Math.round(width * height / 900); i++) {
          const alpha = random() * .7 + .15, size = random() + .25;
          ctx.beginPath(); ctx.arc(random() * width, random() * height, size, 0, 7);
          ctx.fillStyle = `rgba(236,240,250,${alpha})`; ctx.fill();
        }
        const x = width * .6, y = height * .45;
        const glow = ctx.createRadialGradient(x,y,0,x,y,9);
        glow.addColorStop(0,'rgba(255,255,255,.95)'); glow.addColorStop(.25,'rgba(220,230,255,.45)'); glow.addColorStop(1,'rgba(220,230,255,0)');
        ctx.fillStyle=glow; ctx.beginPath(); ctx.arc(x,y,9,0,7); ctx.fill();
        ctx.fillStyle='#fff'; ctx.beginPath(); ctx.arc(x,y,1.6,0,7); ctx.fill();
      }
      function sync() {
        if (reduced.matches) { phone.dataset.state='done'; button.hidden=true; }
        else {
          button.hidden=false;
          if (visible && !started) { phone.dataset.state='play'; started=true; }
        }
        phone.classList.toggle('is-paused', paused || !visible || document.hidden);
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? button.dataset.resume : button.dataset.pause;
      }
      button.addEventListener('click',()=>{paused=!paused;sync();});
      reduced.addEventListener('change',()=>{started=false;sync();});
      document.addEventListener('visibilitychange',sync);
      new ResizeObserver(draw).observe(sky);
      if ('IntersectionObserver' in window) new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.35}).observe(phone);
      else { visible=true;sync(); }
      draw();sync();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
